import styled from 'styled-components';
import theme from 'styles/theme';

export const BreadcrumbsWrapper = styled.div`
  img {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }

  li > span {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  ol > li.active > span:last-child {
    font-weight: bold;
    color: ${theme.colors.dark};
  }
`;
